

export class CompanyIdRequest {
    companyId: number;
    username: string;

    /**
     * 
     * @param companyId 
     * @param username 
     */
    constructor(companyId: number, username: string) {
        this.companyId = companyId;
        this.username = username;
    }
}
